import flow from 'lodash/flow';
import ignoreInstagramAutofillCallbackError from './ignoreInstagramAutofillCallbackError';

export default flow([ignoreInstagramAutofillCallbackError]);
